var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.749C1.5875 14.749 1.23438 14.6021 0.940625 14.3084C0.646875 14.0146 0.5 13.6615 0.5 13.249V4.99902C0.5 4.58652 0.646875 4.2334 0.940625 3.93965C1.23438 3.6459 1.5875 3.49902 2 3.49902H5V1.99902C5 1.58652 5.14687 1.2334 5.44062 0.939648C5.73437 0.645898 6.0875 0.499023 6.5 0.499023H9.5C9.9125 0.499023 10.2656 0.645898 10.5594 0.939648C10.8531 1.2334 11 1.58652 11 1.99902V3.49902H14C14.4125 3.49902 14.7656 3.6459 15.0594 3.93965C15.3531 4.2334 15.5 4.58652 15.5 4.99902V13.249C15.5 13.6615 15.3531 14.0146 15.0594 14.3084C14.7656 14.6021 14.4125 14.749 14 14.749H2ZM2 13.249H14V4.99902H2V13.249ZM6.5 3.49902H9.5V1.99902H6.5V3.49902Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/Bag.f0e89b9de94870227ecb97209ee0c8f5.svg";
export { ForwardRef as ReactComponent };